import { render, staticRenderFns } from "./IpPainMeds.vue?vue&type=template&id=3d5eb026&scoped=true&"
import script from "./IpPainMeds.vue?vue&type=script&lang=js&"
export * from "./IpPainMeds.vue?vue&type=script&lang=js&"
import style0 from "./IpPainMeds.vue?vue&type=style&index=0&id=3d5eb026&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5eb026",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBreadcrumbs,VCard,VCardText,VContainer,VFlex,VLayout})
